const OrthancIcon = () => {
  return (
    <svg width="22" height="20" viewBox="0 0 72.000000 68.000000" xmlns="http://www.w3.org/2000/svg">
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#fefefe" stroke="none">
    <path d="M0 340 l0 -340 360 0 360 0 0 340 0 340 -360 0 -360 0 0 -340z m320
280 l0 -30 -98 0 -98 0 -12 -12 -12 -12 0 -93 0 -93 -30 0 -30 0 0 100 0 99
31 36 31 35 109 0 109 0 0 -30z m319 14 c13 -9 29 -32 37 -50 l14 -33 0 -86 0
-85 -35 0 -34 0 -3 103 -3 102 -107 3 -108 3 0 29 0 30 108 0 108 0 23 -16z
m-359 -189 l0 -75 80 0 79 0 3 73 3 72 43 3 42 3 0 -181 0 -181 -42 3 -43 3
-3 68 -3 67 -79 0 -80 0 0 -70 0 -70 -50 0 -50 0 0 180 0 180 50 0 50 0 0 -75z
m-180 -238 l0 -93 12 -12 12 -12 98 0 98 0 0 -30 0 -30 -109 0 -109 0 -31 35
-31 36 0 99 0 100 30 0 30 0 0 -93z m590 8 l0 -86 -14 -33 c-8 -18 -24 -41
-37 -50 l-23 -16 -108 0 -108 0 0 30 0 29 108 3 107 3 3 103 3 102 34 0 35 0
0 -85z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
    <path d="M61 625 l-31 -36 0 -109 0 -110 40 0 40 0 0 93 0 93 12 12 12 12 98
0 98 0 0 40 0 40 -119 0 -119 0 -31 -35z" />
    <path d="M390 620 l0 -39 108 -3 107 -3 3 -102 3 -103 44 0 45 0 0 95 0 96
-14 33 c-8 18 -24 41 -37 50 l-23 16 -118 0 -118 0 0 -40z" />
    <path d="M190 340 l0 -190 50 0 50 0 0 70 0 70 75 0 75 0 0 -70 0 -70 50 0 50
0 0 190 0 190 -50 0 -50 0 0 -75 0 -75 -75 0 -75 0 0 75 0 75 -50 0 -50 0 0
-190z" />
    <path d="M608 208 l-3 -103 -107 -3 -108 -3 0 -39 0 -40 118 0 118 0 23 16
c13 9 29 32 37 50 l14 33 0 96 0 95 -45 0 -44 0 -3 -102z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#459ed6" stroke="none">
    <path d="M30 200 l0 -109 31 -36 31 -35 119 0 119 0 0 40 0 40 -98 0 -98 0
-12 12 -12 12 0 93 0 93 -40 0 -40 0 0 -110z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#3b3b3b" stroke="none">
    <path d="M598 653 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z" />
    <path d="M390 588 c0 -5 46 -7 103 -6 106 1 94 6 -31 10 -39 2 -72 0 -72 -4z" />
    <path d="M681 584 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
    <path d="M178 583 c28 -2 76 -2 105 0 28 2 5 3 -53 3 -58 0 -81 -1 -52 -3z" />
    <path d="M32 473 c-1 -57 1 -103 6 -103 4 0 6 33 4 72 -4 125 -9 137 -10 31z" />
    <path d="M170 520 c0 -5 6 -10 14 -10 8 0 18 5 21 10 l6 10 -20 0 c-12 0 -21
-4 -21 -10z" />
    <path d="M170 160 c0 -5 9 -10 21 -10 l20 0 -6 10 c-3 6 -13 10 -21 10 -8 0
-14 -4 -14 -10z" />
    <path d="M681 94 l1 -19 5 13 c3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
    <path d="M390 93 c0 -5 33 -7 72 -5 125 4 137 9 31 10 -57 1 -103 -1 -103 -5z" />
    <path d="M598 23 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#090909" stroke="none">
    <path d="M85 650 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0 -13
-4 -16 -10z" />
    <path d="M123 653 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
    <path d="M110 569 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z" />
    <path d="M685 570 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0
-2 -4 1 -10z" />
    <path d="M170 340 l0 -186 18 0 17 0 0 186 0 186 -17 0 -18 0 0 -186z" />
    <path d="M684 108 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#c9c9c9" stroke="none">
    <path d="M393 620 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
    <path d="M694 475 c0 -55 1 -76 3 -47 2 29 2 74 0 100 -2 26 -3 2 -3 -53z" />
    <path d="M280 378 c0 -5 36 -8 80 -8 44 0 80 3 80 8 0 4 -36 7 -80 7 -44 0
-80 -3 -80 -7z" />
    <path d="M280 293 c0 -5 38 -8 85 -8 47 0 85 3 85 8 0 4 -38 7 -85 7 -47 0
-85 -3 -85 -7z" />
    <path d="M694 205 c0 -55 1 -76 3 -47 2 29 2 74 0 100 -2 26 -3 2 -3 -53z" />
    <path d="M393 60 c0 -25 2 -35 4 -22 2 12 2 32 0 45 -2 12 -4 2 -4 -23z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#f6f7f7" stroke="none">
    <path d="M85 650 l-6 -10 15 6 c18 7 21 14 7 14 -6 0 -13 -4 -16 -10z" />
    <path d="M174 340 c0 -107 2 -151 3 -97 2 53 2 141 0 195 -1 53 -3 9 -3 -98z" />
    <path d="M437 523 c-4 -3 -7 -39 -7 -80 l0 -73 10 0 10 0 0 80 c0 44 -1 80 -3
80 -2 0 -7 -3 -10 -7z" />
    <path d="M437 293 c-11 -10 -8 -131 3 -138 l10 -6 0 75 c0 42 -1 76 -3 76 -2
0 -7 -3 -10 -7z" />
    <path d="M30 101 c0 -6 4 -13 10 -16 l10 -6 -6 15 c-7 18 -14 21 -14 7z" />
    <path d="M87 29 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 l-18 7 12 -12z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#9b9b9b" stroke="none">
    <path d="M660 623 c13 -18 25 -33 27 -33 8 0 -17 38 -33 51 l-18 14 24 -32z" />
    <path d="M114 568 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z" />
    <path d="M612 468 l-2 -98 45 0 c25 0 45 3 45 8 0 4 -18 6 -40 4 l-39 -4 -4
93 -3 94 -2 -97z" />
    <path d="M275 520 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0 -7
-4 -4 -10z" />
    <path d="M48 373 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" />
    <path d="M612 213 l2 -98 3 94 4 93 39 -4 c22 -2 40 0 40 4 0 5 -20 8 -45 8
l-45 0 2 -97z" />
    <path d="M275 160 c-3 -5 -1 -10 4 -10 6 0 11 5 11 10 0 6 -2 10 -4 10 -3 0
-8 -4 -11 -10z" />
    <path d="M660 58 l-24 -33 18 14 c16 13 41 51 33 51 -2 0 -14 -15 -27 -32z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#6fb3de" stroke="none">
    <path d="M32 208 c1 -107 6 -95 10 30 2 39 0 72 -4 72 -5 0 -7 -46 -6 -102z" />
    <path d="M188 93 c29 -2 74 -2 100 0 26 2 2 3 -53 3 -55 0 -76 -1 -47 -3z" />
    <path d="M40 83 c0 -5 12 -20 28 -34 l27 -24 -25 30 c-14 17 -26 32 -27 34 -2
2 -3 0 -3 -6z" />
    <path d="M113 23 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#606060" stroke="none">
    <path d="M108 653 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 l-19 -1 13 -5z" />
    <path d="M30 570 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
    <path d="M525 340 c0 -104 3 -190 8 -190 4 0 7 86 7 190 0 105 -3 190 -7 190
-5 0 -8 -85 -8 -190z" />
    <path d="M280 380 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
    <path d="M280 290 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#181818" stroke="none">
    <path d="M670 610 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
    <path d="M124 578 l-7 -11 11 7 c7 4 12 9 12 12 0 8 -9 4 -16 -8z" />
    <path d="M606 567 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 l-12 12 7 -18z" />
    <path d="M438 450 c-2 -44 0 -80 4 -80 3 0 8 36 10 80 2 44 0 80 -4 80 -3 0
-8 -36 -10 -80z" />
    <path d="M441 228 c0 -43 2 -78 7 -78 4 0 6 24 4 52 -5 95 -9 104 -11 26z" />
    <path d="M606 113 l-7 -18 12 12 c7 7 10 15 7 18 -3 3 -9 -2 -12 -12z" />
    <path d="M670 70 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#313131" stroke="none">
    <path d="M59 623 l-14 -18 18 14 c16 13 21 21 13 21 -2 0 -10 -8 -17 -17z" />
    <path d="M205 525 c23 -8 83 -10 79 -3 -3 4 -24 8 -47 7 -23 0 -37 -2 -32 -4z" />
    <path d="M463 523 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z" />
    <path d="M240 160 l-45 -7 42 -1 c23 -1 45 3 48 8 3 6 5 9 3 8 -2 0 -23 -4
-48 -8z" />
    <path d="M463 153 c15 -2 39 -2 55 0 15 2 2 4 -28 4 -30 0 -43 -2 -27 -4z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#7c7c7c" stroke="none">
    <path d="M283 450 c0 -41 2 -58 4 -37 2 20 2 54 0 75 -2 20 -4 3 -4 -38z" />
    <path d="M283 225 c0 -38 2 -53 4 -32 2 20 2 52 0 70 -2 17 -4 1 -4 -38z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#d4d4d4" stroke="none">
    <path d="M610 656 c0 -2 7 -7 16 -10 l15 -6 -6 10 c-6 10 -25 14 -25 6z" />
    <path d="M620 30 l-15 -10 12 0 c6 0 15 5 18 10 8 12 4 12 -15 0z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#b5d7ee" stroke="none">
    <path d="M48 303 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z" />
    <path d="M115 110 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0
-2 -4 1 -10z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#eeeeee" stroke="none">
    <path d="M633 643 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
    <path d="M35 589 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z" />
    <path d="M690 380 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
    <path d="M690 300 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
    <path d="M633 33 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#c8e1f2" stroke="none">
    <path d="M30 110 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
    <path d="M45 70 c3 -5 8 -10 11 -10 3 0 2 5 -1 10 -3 6 -8 10 -11 10 -3 0 -2
-4 1 -10z" />
    <path d="M103 23 c4 -3 10 -3 14 0 3 4 0 7 -7 7 -7 0 -10 -3 -7 -7z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#232323" stroke="none">
    <path d="M40 600 c0 -7 3 -10 7 -7 3 4 3 10 0 14 -4 3 -7 0 -7 -7z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#c5c5c5" stroke="none">
    <path d="M44 608 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#898989" stroke="none" />
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#8ec3e5" stroke="none" />
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#6e6e6e" stroke="none" />
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#494949" stroke="none">
    <path d="M74 638 l-7 -11 11 7 c12 7 16 16 8 16 -3 0 -8 -5 -12 -12z" />
  </g>
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#b8b8b8" stroke="none" />
  <g transform="translate(0.000000,68.000000) scale(0.100000,-0.100000)" fill="#ababab" stroke="none" />
</svg>
  );
};

export default OrthancIcon;
